import type { LottieComponentProps } from 'lottie-react';
import dynamic from 'next/dynamic';

// The Lottie code is lazy-loaded: it's downloaded when the first spinner animation renders, and then reused until the
// next full page load. While it downloads (usually a fraction of a second), React hides everything up to the closest
// <Suspense>.
// Without the `loading` option, next/dynamic adds no <Suspense> of its own, so the closest one is the page's:
// - In production, the whole page flickers briefly.
// - In development (Strict Mode), React also re-runs the page's effects when it's shown again, which aborts requests
//   in flight (e.g. placeOrder when clicking "Betala").
// With `loading`, next/dynamic wraps only the animation in a <Suspense>, so nothing else is affected.
const DynamicLottie = dynamic(() => import('./LottiePlayerInternal' /* webpackChunkName: 'LottiePlayer' */), {
  loading: () => null,
});

const LottiePlayer = (props: LottieComponentProps) => {
  return <DynamicLottie {...props} />;
};

export default LottiePlayer;
